
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/all-articles",
      function () {
        return require("private-next-pages/blog/all-articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/all-articles"])
      });
    }
  